export default class SeatSelectionSetting {
  constructor() {
    this.seatSelectionSetting = document.querySelector('#seat-selection-setting')
    this.chooseOwnSeat = document.querySelector('#choose-own-seat')
    this.init = this.init.bind(this)
    this.checkMobileDevice = this.checkMobileDevice.bind(this)

    this.init()
  }
  init() {
    if (this.seatSelectionSetting && this.seatSelectionSetting.value !== '') {
      const mobileDevice = this.checkMobileDevice()
      if (mobileDevice) {
        if (this.seatSelectionSetting.value === 'hide-mobile' || this.seatSelectionSetting.value === 'hide') this.chooseOwnSeat.style.cssText = 'display: none'
      }
      else {
        if (this.seatSelectionSetting.value === 'hide') this.chooseOwnSeat.style.cssText = 'display: none'
      }
    }
    else return false
  }
  checkMobileDevice() {
    if (navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
    ) return true
    else return false
  }
}